<mat-dialog-content class="">
  <h3 class="mb-3"><i class="fas fa-plus mr-1"></i> Update Vehicle</h3>
  <form class="example-form input-content" [formGroup]="form">
    <div class="row">
      <div class="col-md-6 col-sm-12 pl-0">
        <mat-form-field class="example-full-width" hidden>
          <input type="text" matInput formControlName="id" />
        </mat-form-field>
        <mat-form-field class="example-full-width">
          <mat-label>Name</mat-label>
          <input type="text" matInput formControlName="name" />
        </mat-form-field>
      </div>
      <div class="col-md-6 col-sm-12 pl-0">
        <mat-form-field class="example-full-width">
          <mat-label>Make</mat-label>
          <input type="text" matInput formControlName="make" />
        </mat-form-field>
      </div>
      <div class="col-md-6 col-sm-12 pl-0">
        <mat-form-field class="example-full-width">
          <mat-label>Model</mat-label>
          <input type="text" matInput formControlName="model" />
        </mat-form-field>
      </div>
      <div class="col-md-6 col-sm-12 pl-0">
        <mat-form-field class="example-full-width">
          <mat-label>Variant</mat-label>
          <input type="text" matInput formControlName="variant" />
        </mat-form-field>
      </div>
      <div class="col-md-6 col-sm-12 pl-0">
        <mat-form-field class="example-full-width">
          <mat-label>Color</mat-label>
          <input type="text" matInput formControlName="color" />
        </mat-form-field>
      </div>
      <div class="col-md-6 col-sm-12 pl-0">
        <mat-form-field class="example-full-width">
          <mat-label>License Plate</mat-label>
          <input type="text" matInput formControlName="lpn" readonly />
        </mat-form-field>
      </div>
      <div class="col-md-6 col-sm-12 pl-0">
        <mat-form-field class="example-full-width">
          <mat-label>Peo Id</mat-label>
          <mat-select formControlName="peoId">
            <mat-option
              *ngFor="let userObject of userList"
              [(value)]="userObject.userId"
            >
              {{ userObject.firstName + userObject.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-6 col-sm-12 pl-0">
        <mat-form-field class="example-full-width">
          <mat-label>Camera Group Id</mat-label>
          <mat-select formControlName="cameraGroupId">
            <mat-option
              *ngFor="let cameraObject of cameraGroupList"
              [(value)]="cameraObject.id"
            >
              {{ cameraObject.groupName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    class="btn btn-success float-right mr-2"
    type="submit"
    (click)="updateVehicle()"
  >
    <i class="fas fa-save mr-1"></i> Update
  </button>
  <button class="btn btn-danger float-right" (click)="closeDialog()">
    <i class="fas fa-times mr-1"></i> Close
  </button>
</mat-dialog-actions>
